<div class="page gray-font-color font-family employment-history">
  <div class="header-navigation-back">
    <mat-icon (click)="goBack()" data-test="back-arrow-icon" data-testid="backArrow">arrow_back</mat-icon>
    <span class="title" data-test="edit-button">Employment Form</span>
  </div>
  <div>
    @if (errorMessage) {
    <mat-error class="error padding-left-md">
      {{ errorMessage }}
    </mat-error>
    }
  </div>
  @if (!isContentReady) {
  <app-skeleton-emp-residence-history isResidenceHistory="false"></app-skeleton-emp-residence-history>
  }
  @if (!isContentReady) {
  <app-loading-gif></app-loading-gif>
  }
  <div [hidden]="!isContentReady">
    <div class="content">
      <div class="component-container">
        <div [formGroup]="form" class="modern-form-card">
          <div class="form-section-header">{{ editFormTitle }}</div>
          <div class="form-fields-container">
            <mat-form-field appearance="outline">
              <mat-label>Employer Name</mat-label>
              <input matInput #employer formControlName="employer" required data-test="employer-name-form-field"
                data-testid="employer-name-form-field" />
              @if (employer.touched && employer.invalid) {
              <mat-error>
                {{ getEmployerNameErrorMessage() }}
              </mat-error>
              }
            </mat-form-field>
            <mat-checkbox
              [checked]="!isGoogleAddressLookupEnabled"
              (change)="onGoogleAddressLookupToggle($event)"
              data-testid="google-address-lookup-toggle">
              Enter address from outside Canada or USA
            </mat-checkbox>

            @if (isGoogleAddressLookupEnabled) {
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Employer Address</mat-label>
              <input matInput #empAddressText formControlName="employerAddress" data-test="employer-address-field"
                data-testid="employer-address-field" required autocomplete="on" />
              @if (employerAddress.touched && employerAddress.invalid) {
              <mat-error>
                {{ getEmployerAddressErrorMessage() }}
              </mat-error>
              }
            </mat-form-field>
            } @else {
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Street Address</mat-label>
              <input matInput formControlName="streetAddress" data-testid="street-address-field" />
              @if (form.get('streetAddress')?.touched && form.get('streetAddress')?.invalid) {
              <mat-error>
                {{ getRequiredFieldMessage('streetAddress') }}
              </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="full-width" appearance="outline">
              <mat-label>City</mat-label>
              <input matInput formControlName="city" data-testid="city-field" />
              @if (form.get('city')?.touched && form.get('city')?.invalid) {
              <mat-error>
                {{ getRequiredFieldMessage('city') }}
              </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Province / State</mat-label>
              <input matInput formControlName="province" data-testid="province-field" />
              @if (form.get('province')?.touched && form.get('province')?.invalid) {
              <mat-error>
                {{ getRequiredFieldMessage('province') }}
              </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Postal / Zip Code</mat-label>
              <input matInput formControlName="zipCode" data-testid="zipcode-field" />
              @if (form.get('zipCode')?.touched && form.get('zipCode')?.invalid) {
              <mat-error>
                {{ getRequiredFieldMessage('zipCode') }}
              </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Country</mat-label>
              <input matInput formControlName="country" data-testid="country-field" />
              @if (form.get('country')?.touched && form.get('country')?.invalid) {
              <mat-error>
                {{ getRequiredFieldMessage('country') }}
              </mat-error>
              }
            </mat-form-field>
            }
            <!-- FROM Date: Month and Year Dropdowns -->
            <div class="date-selector-row" #datePickerSection>
              <mat-form-field class="half-width" appearance="outline">
                <mat-label>FROM MONTH</mat-label>
                <mat-select formControlName="fromMonth" data-testid="from-month" required>
                  @for (month of availableFromMonths; track month) {
                  <mat-option [value]="month.value">
                    {{ month.name }}
                  </mat-option>
                  }
                </mat-select>
                @if (form.get('fromMonth')?.touched && form.get('fromMonth')?.invalid) {
                <mat-error>
                  Month is required
                </mat-error>
                }
              </mat-form-field>
              
              <mat-form-field class="half-width" appearance="outline">
                <mat-label>FROM YEAR</mat-label>
                <mat-select formControlName="fromYear" data-testid="from-year" required>
                  @for (year of availableFromYears; track year) {
                  <mat-option [value]="year">
                    {{ year }}
                  </mat-option>
                  }
                </mat-select>
                @if (form.get('fromYear')?.touched && form.get('fromYear')?.invalid) {
                <mat-error>
                  Year is required
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- TO Date: Display text for current employment, dropdowns for previous employment -->
            <div class="date-selector-row">
              @if (isFirstRecord || isCurrentEmployment?.value) {
              <!-- Show text for current employment -->
              <div class="half-width current-address-date-display">
                <label class="date-label">TO MONTH</label>
                <div class="date-value">{{ getCurrentMonthName() }}</div>
              </div>
              
              <div class="half-width current-address-date-display">
                <label class="date-label">TO YEAR</label>
                <div class="date-value">{{ getCurrentYear() }}</div>
              </div>
              } @else {
              <!-- Show dropdowns for previous employment -->
              <mat-form-field class="half-width" appearance="outline">
                <mat-label>TO MONTH</mat-label>
                <mat-select formControlName="toMonth" data-testid="to-month" required>
                  @for (month of availableToMonths; track month) {
                  <mat-option [value]="month.value">
                    {{ month.name }}
                  </mat-option>
                  }
                </mat-select>
                @if (form.get('toMonth')?.touched && form.get('toMonth')?.invalid) {
                <mat-error>
                  Month is required
                </mat-error>
                }
              </mat-form-field>
              
              <mat-form-field class="half-width" appearance="outline">
                <mat-label>TO YEAR</mat-label>
                <mat-select formControlName="toYear" data-testid="to-year" required>
                  @for (year of availableToYears; track year) {
                  <mat-option [value]="year">
                    {{ year }}
                  </mat-option>
                  }
                </mat-select>
                @if (form.get('toYear')?.touched && form.get('toYear')?.invalid) {
                <mat-error>
                  Year is required
                </mat-error>
                }
              </mat-form-field>
              }
            </div>

            @if (!isCurrentEmployment?.value && (form.get('toMonth')?.touched || form.get('toYear')?.touched) && form.get('toDate')?.errors?.minDateError) {
            <mat-error class="padding-left-md">
              End date must be after start date.
            </mat-error>
            }
            @if (!isCurrentEmployment?.value && (form.get('toMonth')?.touched || form.get('toYear')?.touched) && form.get('toDate')?.errors?.futureToDateError) {
            <mat-error class="padding-left-md">
              End date cannot be in the future.
            </mat-error>
            }

            <!-- Overlap Error Message -->
            @if (errorMessage) {
            <div class="date-overlap-error">
              <mat-icon class="error-icon">error</mat-icon>
              <div class="error-message">{{ errorMessage }}</div>
            </div>
            }

            <!-- Overlap Warning Message -->
            @if (overlapWarningMessage) {
            <div class="date-overlap-warning">
              <mat-icon class="warning-icon">warning</mat-icon>
              <div class="warning-message">{{ overlapWarningMessage }}</div>
            </div>
            }

            @if (shouldShowPositionField()) {
            <mat-form-field appearance="outline" data-test="position-form-field" data-testid="position-form-field">
              <mat-label>Position Held</mat-label>
              <mat-select formControlName="position" required (selectionChange)="updateValidators()"
                data-testid="positionHeld" [disabled]="!isUSOrCanada(form.get('country')?.value)">
                @if (isUSOrCanada(form.get('country')?.value)) {
                @if (isUSOrCanada(form.get('country')?.value)) {
                <mat-option value="-">--</mat-option>
                }
                @for (position of positions; track position) {
                <mat-option class="dropdown-values" [value]="position.value" data-test="position-form-field-option"
                  [attr.data-testid]="'postion-' + position?.displayName?.toLowerCase()">{{ position.displayName
                  }}</mat-option>
                }
                }
                @if (!isUSOrCanada(form.get('country')?.value)) {
                <mat-option class="dropdown-values" value="other">
                  Other
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            }

            @if (form.get('position').value === 'other') {
            <mat-form-field appearance="outline">
              <mat-label>Other Position Details</mat-label>
              <input matInput formControlName="otherPosition" data-test="other-position-form-field"
                data-testid="other-position-form-field" required />
              @if (otherPosition.touched && otherPosition.invalid) {
              <mat-error>
                {{ getPositionErrorMessage() }}
              </mat-error>
              }
            </mat-form-field>
            }

            @if (form.get('position').value === 'companyDriver' || form.get('position').value === 'ownerOperator') {
            <mat-form-field appearance="outline">
              <mat-label>Assigned Radius</mat-label>
              <mat-select formControlName="assignedRadius" data-testid="assigned-radius" data-test="assigned-radius"
                required>
                @for (radius of assignedRadiusValues; track radius) {
                <mat-option [value]="radius.value" data-test="assigned-radius-value"
                  [attr.data-testid]="'radius-' + radius?.value?.toLowerCase()">
                  {{ radius.label }}
                </mat-option>
                }
              </mat-select>
              @if (assignedRadius.touched && assignedRadius.invalid) {
              <mat-error>
                {{ getRequiredFieldMessage('assignedRadius') }}
              </mat-error>
              }
            </mat-form-field>
            }

            @if (form.get('position').value === 'companyDriver' || form.get('position').value === 'ownerOperator') {
            <mat-form-field appearance="outline">
              <mat-label>License Class</mat-label>
              <mat-select formControlName="licenseType" data-testid="license-class" data-test="license-class" required>
                @for (license of provinceLicenseClass; track license) {
                <mat-option [value]="license" [attr.data-testid]="'type-' + license?.toLowerCase()"
                  data-test="class-value">
                  {{ license }}
                </mat-option>
                }
              </mat-select>
              @if (licenseType.touched && licenseType.invalid) {
              <mat-error>
                {{ getRequiredFieldMessage('licenseType') }}
              </mat-error>
              }
            </mat-form-field>
            }

            @if (form.get('position').value === 'companyDriver' || form.get('position').value === 'ownerOperator') {
            <mat-label class="equipment-type-label">What equipment did you drive?<span class="required-asterisk">*</span>
            </mat-label>
            }

            @if (form.get('position').value === 'companyDriver' || form.get('position').value === 'ownerOperator') {
            <div class="truck-type equipment-pills">
              <div class="equipment-pill" [class.selected]="form.get('dumpTruck').value">
                <mat-checkbox formControlName="dumpTruck" name="dumpTruck" labelPosition="after"
                  data-testid="dump-truck" data-test="dump-truck">Dump Truck</mat-checkbox>
              </div>
              <div class="equipment-pill" [class.selected]="form.get('straightTruck').value">
                <mat-checkbox formControlName="straightTruck" name="straightTruck" labelPosition="after"
                  data-test="st-truck" data-testid="st-truck">St. Truck</mat-checkbox>
              </div>
              <div class="equipment-pill" [class.selected]="form.get('flatbed').value">
                <mat-checkbox formControlName="flatbed" name="flatbed" labelPosition="after"
                  data-testid="flatbed">Flatbed</mat-checkbox>
              </div>
              <div class="equipment-pill" [class.selected]="form.get('dryVan').value">
                <mat-checkbox formControlName="dryVan" name="dryVan" labelPosition="after" data-testid="dry-van"
                  data-test="dry-van">Dry Van</mat-checkbox>
              </div>
              <div class="equipment-pill" [class.selected]="form.get('reefer').value">
                <mat-checkbox formControlName="reefer" name="reefer" labelPosition="after" data-testid="reefer"
                  data-test="reefer">Reefer</mat-checkbox>
              </div>
              <div class="equipment-pill" [class.selected]="form.get('tanker').value">
                <mat-checkbox formControlName="tanker" name="tanker" labelPosition="after"
                  data-testid="tank">Tank</mat-checkbox>
              </div>
              <div class="equipment-pill" [class.selected]="form.get('other').value">
                <mat-checkbox formControlName="other" name="other" labelPosition="after"
                  data-test="other" data-testid="other">Other</mat-checkbox>
              </div>
              @if (form.hasError('atLeastOneCheckboxRequired') && form.touched) {
              <mat-error>
                {{ getRequiredFieldMessage('equipmentType') }}
              </mat-error>
              }
            </div>
            @if (form.get('other').value) {
            <div class="equipment-description-container">
              <mat-form-field appearance="outline" class="equipment-description-field">
                <mat-label>Equipment description</mat-label>
                <input matInput formControlName="equipmentTypeDescription"
                  placeholder="Enter equipment description"
                  data-test="equipment-type-description"
                  data-testid="equipment-type-description"
                  maxlength="500"
                  required />
              </mat-form-field>
              @if ((equipmentTypeDescription.touched || equipmentTypeDescription.dirty) && equipmentTypeDescription.invalid) {
                @if (equipmentTypeDescription.errors?.required) {
                <div class="equipment-description-error">Equipment description is required</div>
                }
                @if (equipmentTypeDescription.errors?.pattern) {
                <div class="equipment-description-error">Description cannot contain &lt; or &gt; characters</div>
                }
              }
            </div>
            }
            }

            @if (
            form.get('country').value === 'Canada' ||
            form.get('country').value === 'CA' ||
            form.get('country').value === 'USA' ||
            form.get('country').value === 'US' ||
            form.get('employerAddress')?.value?.includes('US') ||
            form.get('employerAddress')?.value?.includes('CA') ||
            form.get('employerAddress')?.value?.includes('Canada')
            ) {
            <mat-form-field appearance="outline">
              <mat-label>Reference Contact Name</mat-label>
              <input matInput formControlName="referenceContactName" data-test="reference-contact-name-form-field"
                data-testid="reference-contact-name-form-field" />
              @if (referenceContactName.touched && referenceContactName.invalid) {
              <mat-error>
                {{ getReferenceContactNameErrorMessage() }}
              </mat-error>
              }
            </mat-form-field>
            }

            @if (
            form.get('country').value === 'Canada' ||
            form.get('country').value === 'CA' ||
            form.get('country').value === 'USA' ||
            form.get('country').value === 'US' ||
            form.get('employerAddress')?.value?.includes('US') ||
            form.get('employerAddress')?.value?.includes('CA') ||
            form.get('employerAddress')?.value?.includes('Canada')
            ) {
            <mat-form-field appearance="outline">
              <mat-label>Reference Contact Number</mat-label>
              <input matInput appPhoneMask maxlength="12" formControlName="referenceContactPhoneNumber"
                placeholder="###-###-####"
                data-test="reference-contact-number-form-field" data-testid="reference-contact-number-form-field" />
              @if (referenceContactPhoneNumber.touched && referenceContactPhoneNumber.invalid) {
              <mat-error>
                {{ getreferenceContactPhoneNumberErrorMessage() }}
              </mat-error>
              }
            </mat-form-field>
            }

            @if (
            form.get('country').value === 'Canada' ||
            form.get('country').value === 'CA' ||
            form.get('country').value === 'USA' ||
            form.get('country').value === 'US' ||
            form.get('employerAddress')?.value?.includes('US') ||
            form.get('employerAddress')?.value?.includes('CA') ||
            form.get('employerAddress')?.value?.includes('Canada')
            ) {
            <mat-form-field appearance="outline">
              <mat-label>Reference Email</mat-label>
              <input matInput formControlName="referenceEmail" data-test="reference-email-form-field"
                data-testid="reference-email-form-field" />
              @if (referenceEmail.touched && referenceEmail.invalid) {
              <mat-error>
                {{ getReferenceEmailErrorMessage() }}
              </mat-error>
              }
            </mat-form-field>
            }

            @if (
            form.get('country').value === 'Canada' ||
            form.get('country').value === 'CA' ||
            form.get('country').value === 'USA' ||
            form.get('country').value === 'US' ||
            form.get('employerAddress')?.value?.includes('US') ||
            form.get('employerAddress')?.value?.includes('CA') ||
            form.get('employerAddress')?.value?.includes('Canada')
            ) {
            @if (
            ((!isFirstRecord && !employmentObj) || (employmentObj && !employmentObj?.isCurrentEmployment)) &&
            !isModifyNewCurrentAddress
            ) {
            <mat-form-field appearance="outline">
              <mat-label>Notes / Reason for Leaving</mat-label>
              <input matInput formControlName="reasonForLeaving" data-test="reason-for-leaving-form-field"
                data-testid="reason-for-leaving-form-field" />
            </mat-form-field>
            }
            }
          </div>
        </div>
      </div>
    </div>
    
    <div class="fixed-footer">
      <button mat-button class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button mat-raised-button class="btn-save margin-right-sm" (click)="onSubmit(form)" [disabled]="!form.valid"
        data-test="save-button" data-testid="save-button">
        Save
      </button>
    </div>
  </div>
</div>